import { EmployeeLoadType, useRepositoryQuery } from '@mews-commander/data-access';
import { useUserContext } from '../context';
import { UserType } from '../types';

export const useUserProfilesGet = (userId: string) => {
    const { userType } = useUserContext();

    return useRepositoryQuery('userProfiles', 'get', {
        userId,
        employeeLoadType:
            userType === UserType.Portfolio ? EmployeeLoadType.PortfolioEmployees : EmployeeLoadType.PropertyEmployees,
    });
};
